<template>
  <div class="single_video_link">
    <div class="profile-videos__add">
      <v-alert
        v-if="new_video_duplicate"
        :value="true"
        type="error"
        class="notranslate"
      >{{str.new_video_duplicate}}</v-alert>

      <v-alert
        v-if="this_video && this_video.submitted && this_video.confirmed"
        :value="true"
        type="success"
        class="notranslate"
      >{{ str.already_confirmed }}</v-alert>
      <v-alert
        v-if="this_video && this_video.submitted && !this_video.confirmed"
        :value="true"
        type="error"
        class="notranslate"
      >
        {{ str.not_confirmed }}
        <template v-if="pending_payment_message">
          <a v-if="pending_payment_message['url']"
             :href="pending_payment_message['url']"
             target="_blank"
          >{{pending_payment_message['message']}}</a>
          <a v-else
             href="#"
             @click.prevent="$emit('pay-awards')"
          >{{pending_payment_message['message']}}</a>
        </template>
      </v-alert>

      <v-form v-if="!this_video"
              v-model="new_video.valid"
              ref="new_video_form"
              @submit.prevent="confirmVideo"
      >
        <v-icon class="cancel_single_link notranslate"
                color="rgba(0,0,0,0.38)"
                @click="removeVideo"
        >close</v-icon>
        <div class="row">
          <v-text-field
              class="video_url_input"
              v-model="new_video.url"
              :label="str.video_url"
              :rules="[form_rules.required, form_rules.video]"
              :disabled="new_video.loading"
          ></v-text-field>
          <v-select
              :items="[
              { item_name: str.wedding_film, item_id: 'wedding_film' },
              { item_name: str.pre_wedding_film, item_id: 'pre_wedding_film' },
              { item_name: str.family_film, item_id: 'family_film' },
            ]"
              item-text="item_name"
              item-value="item_id"
              v-model="new_video.category"
              :label="str.film_category"
              :rules="[form_rules.required]"
          ></v-select>
        </div>

        <v-text-field
            class="video_url_input"
            v-model="new_video.title"
            :label="str.video_title"
            :rules="[form_rules.required]"
            :disabled="new_video.loading"
        ></v-text-field>
        <div class="row">
          <div class="single_upload_container">
            <div class="single_upload_container_img"
                 :style="`background-image: url('data:image/jpeg;charset=utf-8;base64,${ new_video.cover }'); width: 128px; height: 72px;`"
            ></div>
            <div class="single_upload_container_btn">
              <input type="file"
                     accept="image/jpeg"
                     ref="cover_uploader"
                     value="cover_uploader"
                     @change="uploadCover"
                     style="display: none"
              />
              <v-btn color="accent"
                     @click.native="onFocusCoverUploader"
                     :loading="loading"
                     :disabled="loading"
              >
                {{str.film_cover}}
                <v-icon class="notranslate" right dark>cloud_upload</v-icon>
              </v-btn>
              <small>{{ str.upload_film_cover_note }}</small>
            </div>
          </div>
          <div class="single_upload_container">
            <div class="single_upload_container_img"
                 :style="`background-image: url('data:image/jpeg;charset=utf-8;base64,${ new_video.poster }'); width: 72px; height: 128px;`"
            ></div>
            <div class="single_upload_container_btn">
              <input type="file"
                     accept="image/jpeg"
                     ref="poster_uploader"
                     value="poster_uploader"
                     @change="uploadPoster"
                     style="display: none"
              />
              <v-btn color="accent"
                     @click.native="onFocusPosterUploader"
                     :loading="loading"
                     :disabled="loading"
              >
                {{str.film_poster}}
                <v-icon class="notranslate" right dark>cloud_upload</v-icon>
              </v-btn>
              <small>{{ str.upload_film_poster_note }}</small>
            </div>
          </div>
        </div>
        <div class="row" style="justify-content: center; margin-top: 24px;">
          <v-btn type="submit"
                 style="color: #fff;"
                 :loading="new_video.loading"
                 :disabled="new_video.loading || !new_video.valid || !new_video.cover || !new_video.poster"
                 color="accent"
          >{{str.confirm}}</v-btn>
        </div>
      </v-form>
      <div v-if="this_video" class="single_video">
        <div class="video_poster"
             :style="`background-image: url(${ poster_url })`"></div>
        <div class="video_cover"
           :style="`background-image: url(${ thumbnail_url })`"></div>
        <div class="video_info">
          <div class="video_title" v-html="this_video.title"></div>
          <div class="video_url">{{this_video.url}}</div>
          <div class="video_category">{{str[this_video.category]}}</div>
        </div>
        <v-tooltip left class="remove_video" v-if="!this_video['submitted']">
          <v-btn slot="activator"
                 flat
                 icon
                 color="rgba(0,0,0,0.54)"
                 @click="removeVideo"
          >
            <v-icon class="notranslate" medium>delete</v-icon>
          </v-btn>
          <span>{{str.remove_video}}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import strings from '../strings/AwardsSingleVideoLink'
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VTooltip from 'vuetify/es5/components/VTooltip/VTooltip'
import VTextField from 'vuetify/es5/components/VTextField/VTextField'
import VForm from 'vuetify/es5/components/VForm/VForm'
import VSelect from 'vuetify/es5/components/VSelect/VSelect'
import { validateImage } from '../utils/functions'
import form_rules_mixin from "../utils/form_rules_mixin";
export default {
  name: 'AwardsSingleVideoLink',
  components: { VTextField, VForm, VAlert, VTooltip, VSelect },
  props: {
    position: {
      type: Number,
      required: true
    },
    videos: {
      type: Array,
      required: true
    },
    pending_payment_message: {
      required: true
    }
  },
  mixins: [
      form_rules_mixin
  ],
  data: () => ({
    loading: false,
    error: false,
    new_video_duplicate: false,
    new_video: {
      valid: false,
      loading: false,
      url: '',
      title: '',
      category: '',
      cover: null,
      poster: null
    }
  }),
  computed: {
    str: function () {
      const lang = this.$store.state.user.language
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][lang]
        }
      }, {})
    },
    this_video: function () {
      return this.videos[this.position]['url'] ? this.videos[this.position] : false
    },
    thumbnail_url: function () {
      if (this.this_video.thumbnail) {
        return this.this_video.thumbnail
      }
      return this.this_video.cover
          ? (this.this_video.cover.toString().startsWith('http')
              ? ''
              : 'data:image/png;base64,')
          + this.this_video.cover
          : ''
    },
    poster_url: function () {
      if (this.this_video.poster_url) {
        return this.this_video.poster_url
      }
      return this.this_video.poster
          ? (this.this_video.poster.toString().startsWith('http')
              ? ''
              : 'data:image/png;base64,')
          + this.this_video.poster
          : ''
    }
  },
  methods: {
    confirmVideo: async function () {
      this.new_video.loading = true
      this.new_video_duplicate = false
      this.error = false

      const index = this.videos.find(el => el.url === this.new_video.url)
      if (!(index == null)) {
        this.new_video_duplicate = true
        this.new_video.loading = false
        this.new_video.url = ''
        this.new_video.title = ''
        this.new_video.category = ''
        this.new_video.cover = null
        this.new_video.poster = null
      } else {
        this.$emit('submit-video', this.position, {
          url: this.new_video.url,
          title: this.new_video.title,
          category: this.new_video.category,
          cover: this.new_video.cover,
          poster: this.new_video.poster,
        })
        this.new_video.loading = false
      }
    },
    onFocusCoverUploader: function () {
      this.$refs.cover_uploader.click()
    },

    onFocusPosterUploader: function () {
      this.$refs.poster_uploader.click()
    },
    uploadCover: function () {
      validateImage(this.$refs.cover_uploader.files[0], 1280, 720, 10, false)
          .then(data => {
            this.new_video.cover = data
          })
          .catch(() => {
            window.alert(this.$t('There is a problem with the picture you sent'))
          })
    },
    uploadPoster: function () {
      validateImage(this.$refs.poster_uploader.files[0], 720, 1280, 10, false)
          .then(data => {
            this.new_video.poster = data
          })
          .catch(() => {
            window.alert(this.$t('There is a problem with the picture you sent'))
          })
    },
    removeVideo: function () {
      this.$emit('remove-video', this.position)
    },
  }
}
</script>

<style scoped lang="scss">
  .single_video_link {
    margin: 24px 0 0;
    background: #f5f5f5;
    padding: 36px;
    border-radius: 8px;
    position: relative;

    &.submitted > *:not(.v-alert) {
      opacity: 0.6;
    }

    .v-alert {
      margin: 0 0 18px 0;

      a {
        color: #fff;
      }
    }
    .cancel_single_link {
      position: absolute;
      top: 18px;
      right: 18px;
    }

    .v-form {
      clear: both;
      overflow: hidden;
      align-items: center;
      .row {
        display: flex;
        justify-content: space-between;
        .v-input {
          flex: 1;
          &:not(:first-child) {
            margin-left: 18px;
          }
        }
        .single_upload_container {
          display: flex;
          align-items: center;
          justify-content: center;
          &_img {
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            background-color: #ccc;
            margin-right: 12px;
          }
          &_btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .v-btn {
        margin: 0;
      }
    }
    .single_video {
      clear: both;
      position: relative;
      overflow: hidden;
      display: flex;
      .video_poster {
        width: 51px;
        height: 90px;
        border-radius: 2px;
        background-color: #ccc;
        background-size: cover;
        background-position: center center;
        margin-right: 12px;
      }
      .video_cover {
        width: 160px;
        height: 90px;
        border-radius: 2px;
        background-color: #ccc;
        background-size: cover;
        background-position: center center;
      }
      .video_info {
        flex: 1;
        width: calc(100% - 140px);
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .video_title {
        width: calc(100% - 64px);
        overflow: hidden;
        white-space: nowrap;
        line-height: 24px;
        height: 24px;
        font-weight: bold;
        font-size: 16px;
        color: rgba(0,0,0,0.87);
      }
      .video_url {
        white-space: nowrap;
        font-size: 16px;
        line-height: 24px;
        height: 24px;
        color: rgba(0,0,0,0.54);
      }
      .video_category {
        white-space: nowrap;
        font-size: 16px;
        line-height: 24px;
        height: 24px;
        color: rgba(0,0,0,0.54);
      }
      .remove_video {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        background: transparent;
      }
    }
  }
</style>
